import { render, staticRenderFns } from "./GestioneLayout.vue?vue&type=template&id=27f34f53&"
import script from "./GestioneLayout.vue?vue&type=script&lang=js&"
export * from "./GestioneLayout.vue?vue&type=script&lang=js&"
import style0 from "./GestioneLayout.vue?vue&type=style&index=0&id=27f34f53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports